import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  loadAllCommunityProducts,
  loadAllCommunityProductsSuccess,
  loadAllCommunityProductsFailure
} from './community-product.action';
import { CustomerService } from '../../services/customer.service';
import { ApiResponse } from '../../models/common.model';
import { Action } from '@ngrx/store';

interface HttpError {
  message?: string;
  status?: number;
}

@Injectable()
export class ProductEffects {
  constructor(
    private actions$: Actions,
    private customerService: CustomerService
  ) { }

  // Effect to load all products (no filters)
  loadAllProducts$ = createEffect((): Observable<Action> =>
    this.actions$.pipe(
      ofType(loadAllCommunityProducts),
      switchMap((action: {
        basedProduct?: string,
        page?: number,
        orderBy?: string,
        categoryId?: string,
        subRegionId?: any,
        limit?: number,
        isPopular?: boolean,
      }) =>
        this.customerService.getMemberShopProductList({
          ...action,
          categoryId: action.categoryId,
          subRegionId: action.subRegionId,
        })
          .pipe(
            map((response: ApiResponse) =>
              loadAllCommunityProductsSuccess({ communityProducts: response.body || [] })
            ),
            catchError((error: HttpError) => {
              console.error('Error loading products:', error);
              return of(
                loadAllCommunityProductsFailure({
                  error: {
                    message: error.message || 'An unknown error occurred',
                    statusCode: error.status || 500,
                  },
                })
              );
            })
          )
      )
    )
  );
}
